import { foldazApi } from 'api'

import { apolloClient } from '@/graphql/apollo'
import copyContentToFolderGql from '@/graphql/mutation/copyContentToFolder.gql'

import {
  FETCH_CONTENTS_REQUEST,
  FETCH_CONTENTS_SUCCESS,
  FETCH_CONTENTS_ERROR,
  SET_CONTENTS,
  SET_META,
  PREPEND_CONTENTS,
  APPEND_CONTENTS
} from './types'

export const state = {
  contents: [],
  meta: null,
  request: {
    isLoading: false,
    error: null
  }
}

export const mutations = {
  [FETCH_CONTENTS_REQUEST] (state) {
    state.request.isLoading = true
  },
  [FETCH_CONTENTS_SUCCESS] (state) {
    state.request.isLoading = false
    state.request.error = null
  },
  [FETCH_CONTENTS_ERROR] (state, error) {
    state.request.isLoading = false
    state.request.error = error
  },
  [SET_META] (state, value) {
    state.meta = value
  },
  [SET_CONTENTS] (state, value) {
    state.contents = value
  },
  [PREPEND_CONTENTS] (state, value) {
    state.contents.unshift(...value)
  },
  [APPEND_CONTENTS] (state, value) {
    state.contents.push(...value)
  }
}

export const actions = {
  fetch ({ commit, rootState }) {
    commit(FETCH_CONTENTS_REQUEST)

    const filter = rootState.contentFilter.filter
    const folders = filter && filter.folderIds
      ? filter.folderIds.join(',')
      : ''
    const tags = filter && filter.tags
      ? filter.tags.join(',')
      : ''
    const countries = filter && filter.countries
      ? filter.countries.map(({ value }) => (value)).join(', ')
      : ''

    const createdAtFrom = filter.createdAtFrom ? filter.createdAtFrom : filter.initializedAtFrom
    const createdAtUntil = filter.createdAtUntil ? filter.createdAtUntil : filter.initializedAtUntil

    const params = filter === undefined
      ? {}
      : {
        term: filter.term,
        folder_ids: folders,
        tags: tags,
        source_name: filter.sourceName,
        created_at_from: createdAtFrom,
        created_at_until: createdAtUntil,
        published_at_from: filter.publishedAtFrom,
        published_at_until: filter.publishedAtUntil,
        priority: filter.priority,
        external: filter.external,
        countries: countries,
        sort_by: filter.sortBy,
        sort_dir: filter.sortDir,
        page: filter.page,
        per_page: filter.perPage
      }

    return new Promise(function (resolve, reject) {
      foldazApi.get('/contents', {
        params: params
      })
        .then(response => {
          commit(FETCH_CONTENTS_SUCCESS)
          resolve(response.data)
        })
        .catch(error => {
          commit(FETCH_CONTENTS_ERROR, error)
          reject(error)
        })
    })
  },
  fetchForFolder ({ dispatch }, folderId) {
    dispatch('contentFilter/setFolderIds', [folderId], {root:true})
    return dispatch('fetch')
  },
  copyToFolder ({}, {contentId, folderId}) {
    return apolloClient.mutate({
      mutation: copyContentToFolderGql,
      variables: {
        contentId: contentId,
        folderId: folderId
      }
    })
  },
  nextPage ({ dispatch, rootState }) {
    const filter = rootState.contentFilter.filter

    dispatch('contentFilter/setPage', parseInt(filter.page, 10) + 1, {root:true})
    dispatch('fetch')
      .then((response) => {
        dispatch('append', response)
      })
  },
  apply ({ commit }, response) {
    commit(SET_META, response.meta)
    commit(SET_CONTENTS, response.entries)
  },
  prepend ({ commit }, response) {
    commit(PREPEND_CONTENTS, response.entries)
  },
  append ({ commit }, response) {
    commit(SET_META, response.meta)
    commit(APPEND_CONTENTS, response.entries)
  },
  reset ({ commit }) {
    commit(SET_META, null)
    commit(SET_CONTENTS, [])
  }
}

export const getters = {
  contentsOptions ({ contents }) {
    return contents.map(({ id, name }) => ({ label: name, value: id }))
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/contents/contents.js